__turbopack_context__.v({
  "bottomContent": "slIFSG_bottomContent",
  "ctaContainer": "slIFSG_ctaContainer",
  "expandableRoot": "slIFSG_expandableRoot",
  "moreParameter": "slIFSG_moreParameter",
  "testCardRoot": "slIFSG_testCardRoot",
  "topContent": "slIFSG_topContent",
});
